module.exports = __webpack_public_path__ + "img/Tablet - 69.06f26d17.png";